var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewfeature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_1455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18734 15.5833V12.0417M3.18734 4.95832V1.41666M1.4165 3.18749H4.95817M1.4165 13.8125H4.95817M9.20817 2.12499L7.97979 5.31877C7.78004 5.83814 7.68016 6.09782 7.52484 6.31626C7.38718 6.50985 7.21804 6.679 7.02444 6.81666C6.806 6.97198 6.54632 7.07186 6.02695 7.27161L2.83317 8.49999L6.02695 9.72837C6.54632 9.92812 6.80601 10.028 7.02444 10.1833C7.21804 10.321 7.38718 10.4901 7.52484 10.6837C7.68016 10.9022 7.78004 11.1618 7.9798 11.6812L9.20817 14.875L10.4365 11.6812C10.6363 11.1618 10.7362 10.9022 10.8915 10.6837C11.0292 10.4901 11.1983 10.321 11.3919 10.1833C11.6103 10.028 11.87 9.92812 12.3894 9.72836L15.5832 8.49999L12.3894 7.27161C11.87 7.07186 11.6103 6.97198 11.3919 6.81666C11.1983 6.679 11.0292 6.50985 10.8915 6.31626C10.7362 6.09782 10.6363 5.83814 10.4365 5.31877L9.20817 2.12499Z",
    stroke: "#F37845",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_1455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewfeature);
export default __webpack_public_path__ + "static/media/newfeature.26ae5414c6e7cf217bee702471174855.svg";
export { ForwardRef as ReactComponent };